import { t } from 'i18next';
import React from 'react';
import { useSelector } from 'react-redux';

// Module-level flag — ensures the TrustArc script is loaded only once
// across all LegalLinks instances and navigations
let trustArcScriptLoaded = false;

const LegalLinks = () => {
    const envState = useSelector(state => state.env);
    const consentRef = React.useRef(null);
    const [trustArcState, setTrustArcState] = React.useState({
        btnDetected: false,
        removeSpacing: false,
        bannerHidden: false
    });

    // Create a persistent consent-banner div in document.body (outside React)
    // and load the TrustArc script once for the entire app lifecycle.
    React.useEffect(() => {
        if (!envState) return;

        let bannerDiv = document.getElementById('consent-banner');
        if (!bannerDiv) {
            bannerDiv = document.createElement('div');
            bannerDiv.id = 'consent-banner';
            bannerDiv.style.cssText = 'left: 0px; bottom: 0px; position: fixed; z-index: 999; width: 100%;';
            document.body.appendChild(bannerDiv);
        }
        consentRef.current = bannerDiv;

        if (!trustArcScriptLoaded) {
            const script = document.createElement('script');
            script.id = 'trust-arc-scr';
            script.src = 'https://consent.trustarc.com/v2/notice/hhocnm';
            script.async = true;
            document.head.appendChild(script);
            trustArcScriptLoaded = true;
        }
    }, [envState]);

    //remove spacing on style change
    const handleStyleChange = (e) => {
        if(!trustArcState.removeSpacing) setTrustArcState({ ...trustArcState, removeSpacing: true, });
    };

    const detectTrustArcBanner = () => {
        setTrustArcState({
            ...trustArcState,
            btnDetected: true
        });
    }

    const getCookies = () => {
        // Get the cookie string
        const cookieString = document.cookie;
      
        // Split the cookie string into individual cookies
        const cookiesArray = cookieString.split(';');
      
        // Create an object to store the cookies
        const cookies = {};
      
        // Loop through the cookies and add them to the object
        cookiesArray.forEach(cookie => {
          const [name, value] = cookie.trim().split('=');
          cookies[name] = value;
        });
      
        return cookies;
    }

    React.useEffect(() => {  
        const cookiesObj = getCookies();
        const observer = new MutationObserver(handleStyleChange);

        if(!!consentRef?.current && !cookiesObj?.notice_gdpr_prefs) {
            if(!!envState) {
                if(!trustArcState.btnDetected) {
                    document.body.addEventListener('click', detectTrustArcBanner);
                } else {
                    const config = {
                        attributes: true,  // Watch for changes to attributes (including style changes)
                        attributeFilter: ['style'],  // Only watch for changes to the "style" attribute
                    };

                    const trusteConsentEl = document.getElementById("truste-consent-track");
                    if(!!trusteConsentEl) {
                        //Check if banner is hidden
                        const computedStyle = window.getComputedStyle(trusteConsentEl);
                        const displayType = computedStyle.display;

                        if(displayType === "none" && !trustArcState.bannerHidden) setTrustArcState({ ...trustArcState, bannerHidden: true, removeSpacing: true,});
                        else observer.observe(trusteConsentEl, config);
                    }
                }
            }
        } else {
            if(!trustArcState.removeSpacing) setTrustArcState({
                ...trustArcState,
                removeSpacing: true
            })
        }

        return () => {
            document.body.removeEventListener('click', detectTrustArcBanner);
            observer.disconnect();
        };

    }, [envState, trustArcState, consentRef])

    return(
        <div className={`cm-legal-links d-flex flex-wrap cm-xs-txt text-blue-gray-700 mt-4 ${!trustArcState.removeSpacing ? 'cm-trust-arc-open' : '' }`}>
            <a className='text-blue-gray-700' target="_blank" href={`https://${envState.METTL_URL}/terms-of-services`}>{t("terms_of_services")}</a>
            <span className='cm-legal-link-sep' />
            <a className='text-blue-gray-700' target="_blank" href={`https://${envState.METTL_URL}/privacy-notice`}>{t("privacy_notice")}</a>
            <span className='cm-legal-link-sep' />
            <a className='text-blue-gray-700' target="_blank" href={`https://${envState.METTL_URL}/cookies`}>Cookies</a>
            <span className='cm-legal-link-sep' />
            <div id="teconsent" consent="undefined"></div>
        </div>
    )

}

export default LegalLinks;